import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";
import godrej from "./images/property/godrej.jpg";

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Property In West Bengaluru",
  locationtag: "",
  location: [
    {
      name: "Godrej Yeswanthpur ",
      image: godrej,
      price: "On Request",
      location: "Yeshwanthpur",
      bed: "3 & 4 BHK",
      size: "....",
      url: `/godrej-yeswanthpur`,
    },
  ],
};
